"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing60 = exports.spacing56 = exports.spacing52 = exports.spacing48 = exports.spacing44 = exports.spacing40 = exports.spacing36 = exports.spacing32 = exports.spacing28 = exports.spacing24 = exports.spacing20 = exports.spacing18 = exports.spacing16 = exports.spacing14 = exports.spacing12 = exports.spacing10 = exports.spacing8 = exports.spacing6 = exports.spacing4 = exports.spacing2 = void 0;
exports.spacing2 = "2px";
exports.spacing4 = "4px";
exports.spacing6 = "6px";
exports.spacing8 = "8px";
exports.spacing10 = "10px";
exports.spacing12 = "12px";
exports.spacing14 = "14px";
exports.spacing16 = "16px";
exports.spacing18 = "18px";
exports.spacing20 = "20px";
exports.spacing24 = "24px";
exports.spacing28 = "28px";
exports.spacing32 = "32px";
exports.spacing36 = "36px";
exports.spacing40 = "40px";
exports.spacing44 = "44px";
exports.spacing48 = "48px";
exports.spacing52 = "52px";
exports.spacing56 = "56px";
exports.spacing60 = "60px";